import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-532c2ee7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "package-list-wrapper" }
const _hoisted_2 = { class: "package-list-header" }
const _hoisted_3 = { class: "status-wrapper" }
const _hoisted_4 = { class: "icon-wrapper" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "statusText" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "status" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "head" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "inline" }),
  /*#__PURE__*/_createElementVNode("span", { class: "headText" }, "套餐充值")
], -1))
const _hoisted_12 = {
  key: 0,
  class: "package-list-content"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "priceText" }
const _hoisted_15 = { class: "price" }
const _hoisted_16 = { class: "originalPrice" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "unit" }, "￥", -1))
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "packageName" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "inline" }, null, -1))
const _hoisted_21 = {
  key: 0,
  class: "infoText"
}
const _hoisted_22 = {
  key: 1,
  class: "infoText"
}
const _hoisted_23 = {
  key: 2,
  class: "infoText"
}
const _hoisted_24 = {
  key: 3,
  class: "infoText"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 1,
  class: "noPackage"
}
const _hoisted_27 = { class: "ConfirmationPurchase" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "支付", -1))
const _hoisted_29 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }

import wx from "weixin-js-sdk-ts";
  import { computed, ref } from "vue";
  import dxIcon from '@/assets/dx_icon.png'
  import ltIcon from '@/assets/lt_icon.png'
  import ydIcon from '@/assets/yd_icon.png'
  import { useRoute, useRouter } from 'vue-router'
  import {
    postOrderPackage,
    getAgainOrder,
    getCloseAgainOrder,
    getAgentPackageListV2
  } from "@/api";
  import { showDialog, showToast } from "vant";
  import { setWxConfig } from "@/utils";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'packageList',
  setup(__props) {

  const route = useRoute()
  const router = useRouter()

  const operatorMap: Record<number, { name: string; icon: string }> = {
    1: { name: '中国移动', icon: ydIcon },
    2: { name: '中国联通', icon: ltIcon },
    3: { name: '中国电信', icon: dxIcon },
    4: { name: '中国电信', icon: dxIcon }
  }

  const operatorInfo = computed(() => {
    return operatorMap[Number(route.params.operator)] || { name: '未知运营商', icon: dxIcon }
  })
  let againPackageName = ref(); /* 二次支付的套餐名 */
  let againOrderNo = ref(); /* 二次支付的订单号 */
  let againPurchaseShow = ref(false);

  const sourceQuery = () => route.query.source === 'watchHome' ? { source: 'watchHome' } : {}

  const goPackageInfo = (argument: any) => {
    let params = {
      iccid: route.params.iccid,
      ...argument
    }
    router.push({
      name: 'packageInfo',
      params: {
        data: JSON.stringify(params),
      },
      query: sourceQuery()
    })
  }

  function goPurchaseSuccess() {
    router.push({
      name: "packageSucceeds",
      params: {
        iccid: route.params.iccid,
      },
      query: sourceQuery()
    });
  }

  let packageList: any = ref([]);
  const _getAgentPackageListV2 = () => {
    getAgentPackageListV2({
      iccid: route.params.iccid
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res.result)
        packageList.value = res.result;
      }
    })
  }

  //提交订单
  function submitOrder(argument: any) {
    let params = {
      packageId: argument.packageId,
      appId: sessionStorage.getItem("appId"),
      iccid: route.params.iccid,
      userId: sessionStorage.getItem("userId"),
    };
    postOrderPackage(params).then((res: any) => {
      if (res.code == 200) {
        // const { payInfo } = res.result;
        // console.log('--------', payInfo)
        // window.location.href = payInfo;
        // return
        wx.chooseWXPay({
          // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          timestamp: res.result.payInfo.timeStamp,
          // 支付签名随机串，不长于 32 位
          nonceStr: res.result.payInfo.nonceStr,
          // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          package: res.result.payInfo.package,
          // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          signType: res.result.payInfo.signType,
          // 支付签名
          paySign: res.result.payInfo.paySign,
          appId: res.result.payInfo.appId,
          // 支付成功后的回调函数
          success: function () {
            // res.errMsg === 'chooseWXPay:ok'方式判断前端返回,微信团队郑重提示：
            // res.errMsg将在用户支付成功后返回ok，但并不保证它绝对可靠， 切记。
            goPurchaseSuccess();
          },
        });
      } else {
        if (res.code == 214) {
          againPurchaseShow.value = true;
          againPackageName.value = res.message.split("|")[1];
          againOrderNo.value = res.message.split("|")[0];
        } else {
          showDialog({
            message: res.message,
          }).then(() => {
            // on close
          });
        }
      }
    });
  }
  //二次支付
  function againSubmitOrder() {
    againPurchaseShow.value = false;
    let params = {
      orderNo: againOrderNo.value,
    };
    getAgainOrder(params).then((res: any) => {
      if (res.code == 200) {
        // const { payInfo } = res.result;
        // console.log('--------', payInfo)
        // window.location.href = payInfo;
        wx.chooseWXPay({
          // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
          timestamp: res.result.payInfo.timeStamp,
          // 支付签名随机串，不长于 32 位
          nonceStr: res.result.payInfo.nonceStr,
          // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
          package: res.result.payInfo.package,
          // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
          signType: res.result.payInfo.signType,
          // 支付签名
          paySign: res.result.payInfo.paySign,
          appId: res.result.payInfo.appId,
          // 支付成功后的回调函数
          success: function () {
            // res.errMsg === 'chooseWXPay:ok'方式判断前端返回,微信团队郑重提示：
            // res.errMsg将在用户支付成功后返回ok，但并不保证它绝对可靠， 切记。
            goPurchaseSuccess();
          },
        });
      } else {
        showToast(res.message);
      }
    });
  }
  //取消二次支付
  function againCancelOrder() {
    againPurchaseShow.value = false;
    let params = {
      orderNo: againOrderNo.value,
    };
    getCloseAgainOrder(params).then((res: any) => {
      if (res.code == 200) {
        showToast("取消成功");
      } else {
        showToast(res.message);
      }
    });
  }
  _getAgentPackageListV2();
  setWxConfig(["chooseWXPay"]);

return (_ctx: any,_cache: any) => {
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: operatorInfo.value.icon,
            alt: "",
            class: "icon"
          }, null, 8, _hoisted_5)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(operatorInfo.value.name), 1),
          _createElementVNode("div", _hoisted_8, "状态：" + _toDisplayString(_unref(route).params.status), 1)
        ])
      ]),
      _createElementVNode("li", _hoisted_9, "充值卡号: " + _toDisplayString(_unref(route).params.phone), 1),
      _createElementVNode("li", _hoisted_10, "ICCID: " + _toDisplayString(_unref(route).params.iccid), 1)
    ]),
    _hoisted_11,
    (_unref(packageList).length > 0)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "package-item",
              key: index
            }, [
              _createElementVNode("div", {
                class: "priceWrapper",
                onClick: _withModifiers(($event: any) => (submitOrder(item)), ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode("RMB "),
                  _createElementVNode("div", _hoisted_15, _toDisplayString(item.agentSalePrice), 1)
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createTextVNode("原价：" + _toDisplayString(item.packageOriginalPrice) + " ", 1),
                  _hoisted_17
                ])
              ], 8, _hoisted_13),
              _createElementVNode("div", {
                class: "content",
                onClick: _withModifiers(($event: any) => (submitOrder(item)), ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(item.agentPackageName), 1),
                _hoisted_20,
                (item.boundlessFlag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, "专用高速网络通道"))
                  : _createCommentVNode("", true),
                (item.boundlessFlag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, "无限总流量使用数"))
                  : _createCommentVNode("", true),
                (!item.boundlessFlag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, "共享高速网络通道"))
                  : _createCommentVNode("", true),
                (!item.boundlessFlag)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(item.cmeFlowCount.split(".")[0]) + _toDisplayString(Number(item.cycleType) === 3 ? 'GB/月' : 'GB总流量使用数'), 1))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_18),
              _createElementVNode("div", {
                class: "btn",
                onClick: ($event: any) => (goPackageInfo(item))
              }, "查看详情", 8, _hoisted_25)
            ]))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, "暂无套餐")),
    _createVNode(_component_van_popup, {
      show: _unref(againPurchaseShow),
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (_isRef(againPurchaseShow) ? (againPurchaseShow).value = $event : againPurchaseShow = $event)),
      round: "",
      style: { padding: '30px', height: '200px', width: '85%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", null, "您有一笔未支付订单：" + _toDisplayString(_unref(againPackageName)) + "！", 1),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_component_van_button, {
              color: "#DCDEE0",
              block: "",
              onClick: againCancelOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭订单")
              ]),
              _: 1
            }),
            _createVNode(_component_van_button, {
              color: "#6aafff",
              block: "",
              style: {"margin-left":"10px"},
              onClick: againSubmitOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode("再次支付")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})